import { CMD } from "@/be/commands/types";
import { Q } from "@/be/queries/types";
import { RLT } from "@/common/schema/role-types";
import { Int } from "@/fx/data-helpers/likables";
import { Id } from "@/fx/Id";
import { BBC_API } from "../bbc-api/types";
import { SYNC } from "./types";
import { User } from "../bbc-api/_types";

export async function sync({ Q, CMD, BBC_API }: {
  Q:      Q.Service,
  CMD:    CMD.Service,
  BBC_API: BBC_API.Service,
}): Promise<SYNC.Service> {
  return {
    distributorEmployee: async ({ externalUserId, email }: {
        externalUserId: Int,
        email:          string,
    }) => {
      const [externalUser, userId] = await Promise.all([
        BBC_API.GET_user({ userId: externalUserId }),
        Q.user_exists({ email }),
      ]);

      if (externalUser && hasBoomerangAccess(externalUser)) {
        const distributorEmployeeId = await (async (): Promise<bigint> => {
          if (userId) {
            const clmUser = await Q.user({ id: Id.from(userId).asStr });
            if (clmUser.firstName !== externalUser.firstName || clmUser.lastName !== externalUser.lastName) {
              await CMD.updateUser(clmUser.id.asInt, externalUser.firstName, externalUser.lastName);
            }
            return clmUser.id.asInt;
          } else {
            const newId = await CMD.insertUser(externalUser.firstName, externalUser.lastName, email);
            await CMD.insertRole(newId, RLT.RoleType.DIS.identifier);
            await CMD.insertDistributorEmployee({ userId: newId, externalUserId });
            return newId;
          }
        })();

        const allLocations = externalUser.distributors.flatMap((d) => [d, ...(d.locations ?? [])]);

        await Promise.all(allLocations.map(async (location) => {
          const locationId = await Q.distributorLocation_exists({ sapId: location.sapId });
          if (locationId) {
            await CMD.insertDistributorEmployee_AssignedDistributorLocation({ employeeId: distributorEmployeeId, locationId });
          }
        }));
      }
    }
  };
};

function hasBoomerangAccess(user: User): boolean {
  if (!user.active || !user.roles.includes('CLM_DIS') || user.distributors.length === 0) {
    return false;
  }

  return true;
}
